import { useMemo, useRef } from 'react';
import { isEqual } from 'lodash-es';

const EMPTY: string[] = [];

interface GroupShape {
  hypothesis: string;
  creatives: { id: string }[];
}

const useGroupSelectionSlices = (
  groups: readonly GroupShape[],
  selectedCreatives: readonly string[],
): Map<string, string[]> => {
  const previousRef = useRef<Map<string, string[]>>(new Map());

  return useMemo(() => {
    const selectionSet = new Set(selectedCreatives);
    const next = new Map<string, string[]>();
    const previous = previousRef.current;

    for (const group of groups) {
      const nextSlice: string[] = [];
      for (const c of group.creatives) {
        if (selectionSet.has(c.id)) nextSlice.push(c.id);
      }
      const previousSlice = previous.get(group.hypothesis);
      if (nextSlice.length === 0 && (!previousSlice || previousSlice.length === 0)) {
        next.set(group.hypothesis, previousSlice ?? EMPTY);
      } else if (previousSlice && isEqual(previousSlice, nextSlice)) {
        next.set(group.hypothesis, previousSlice);
      } else {
        next.set(group.hypothesis, nextSlice);
      }
    }

    previousRef.current = next;
    return next;
  }, [groups, selectedCreatives]);
};

export default useGroupSelectionSlices;
